import React from "react";
import PropTypes from "prop-types";
import "../../VehiculeForm.css";
import { vehiculeDataPropType } from "../../../../types/vehiculeTypes";

const DisplayTitulairesOccasion = ({ vehiculeData, readOnly }) => {
  return (
    <div className="form-section">
      <div className="section">
        <h3>ANCIEN PROPRIETAIRE - CONCESSION (en cas de cession)</h3>
        <div className="radio-group">
          <label>VOUS ÊTES:</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="occ_app_1"
                value="0"
                checked={vehiculeData.occ_app_1?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>PERSONNE PHYSIQUE</label>
            </div>
            <div>
              <input
                type="radio"
                name="occ_app_1"
                value="1"
                checked={vehiculeData.occ_app_1?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>PERSONNE MORALE</label>
            </div>
          </div>
        </div>

        {vehiculeData.occ_app_1?.toString() === "0" ? (
          <>
            <div className="radio-group">
              <label>SEXE:</label>
              <div className="radio-group-child">
                <div>
                  <input
                    type="radio"
                    name="occ_app_2"
                    value="0"
                    checked={vehiculeData.occ_app_2?.toString() === "0"}
                    readOnly={readOnly}
                  />
                  <label>MASCULIN</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="occ_app_2"
                    value="1"
                    checked={vehiculeData.occ_app_2?.toString() === "1"}
                    readOnly={readOnly}
                  />
                  <label>FÉMININ</label>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>NOM ET PRÉNOM:</label>
              <input
                type="text"
                value={vehiculeData.occ_app_3 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
          </>
        ) : (
          <>
            <div className="form-group">
              <label>RAISON SOCIALE:</label>
              <input
                type="text"
                value={vehiculeData.occ_app_4 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>N° SIRET:</label>
              <input
                type="text"
                value={vehiculeData.occ_app_5 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>N° SIREN:</label>
              <input
                type="text"
                value={vehiculeData.occ_app_5_2 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
          </>
        )}

        <div className="form-group">
          <label>N° DE LA VOIE:</label>
          <input
            type="text"
            value={vehiculeData.occ_app_6 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>COMPLÉMENT (BIS, TER,..):</label>
          <input
            type="text"
            value={vehiculeData.occ_app_7 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>TYPE DE VOIE (RUE, AVENUE..):</label>
          <input
            type="text"
            value={vehiculeData.occ_app_8 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>NOM DE LA VOIE:</label>
          <input
            type="text"
            value={vehiculeData.occ_app_9 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>CODE POSTAL:</label>
          <input
            type="text"
            value={vehiculeData.occ_app_10 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>COMMUNE:</label>
          <input
            type="text"
            value={vehiculeData.occ_app_11 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="radio-group">
          <label>JE CERTIFIE:</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="occ_app_12"
                value="0"
                checked={vehiculeData.occ_app_12?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>CÉDER</label>
            </div>
            <div>
              <input
                type="radio"
                name="occ_app_12"
                value="1"
                checked={vehiculeData.occ_app_12?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>CÉDER POUR DESTRUCTION</label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>LE:</label>
          <div className="date-input-group">
            <div className="date-field">
              <label>JOUR</label>
              <input
                type="text"
                value={vehiculeData.occ_app_13_1 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
                placeholder="JJ"
              />
            </div>
            <div className="date-field">
              <label>MOIS</label>
              <input
                type="text"
                value={vehiculeData.occ_app_13_2 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
                placeholder="MM"
              />
            </div>
            <div className="date-field">
              <label>ANNÉE</label>
              <input
                type="text"
                value={vehiculeData.occ_app_13_3 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
                placeholder="AAAA"
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>A:</label>
          <div className="time-input-group">
            <input
              type="text"
              value={`${vehiculeData.occ_app_14_1 || ""}:${vehiculeData.occ_app_14_2 || ""}`}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>
        </div>

        <div className="checkbox-group">
          <div>
            <input
              type="checkbox"
              checked={vehiculeData.occ_app_15 === "1"}
              readOnly
              disabled={readOnly}
            />
            <label>
              AVOIR REMIS AU NOUVEAU PROPRIÉTAIRE UN CERTIFICAT ÉTABLI DEPUIS MOINS DE QUINZE JOURS...
            </label>
          </div>
          <div>
            <input
              type="checkbox"
              checked={vehiculeData.occ_app_16 === "1"}
              readOnly
              disabled={readOnly}
            />
            <label>
              QUE CE VÉHICULE N&apos;A PAS SUBI DE TRANSFORMATION NOTABLE...
            </label>
          </div>
          <div>
            <input
              type="checkbox"
              checked={vehiculeData.occ_app_17 === "1"}
              readOnly
              disabled={readOnly}
            />
            <label>
              QUE CE VÉHICULE EST CÉDÉ POUR DESTRUCTION À UN PROFESSIONNEL...
            </label>
          </div>
        </div>
      </div>

      <div className="section">
        <h3>TITULAIRE - NOUVEAU PROPRIETAIRE</h3>
        <div className="radio-group">
          <label>VOUS ÊTES:</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="occ_tit_1"
                value="0"
                checked={vehiculeData.occ_tit_1?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>PERSONNE PHYSIQUE</label>
            </div>
            <div>
              <input
                type="radio"
                name="occ_tit_1"
                value="1"
                checked={vehiculeData.occ_tit_1?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>PERSONNE MORALE</label>
            </div>
          </div>
        </div>

        {vehiculeData.occ_tit_1?.toString() === "0" ? (
          <>
            <div className="radio-group">
              <label>SEXE:</label>
              <div className="radio-group-child">
                <div>
                  <input
                    type="radio"
                    name="occ_tit_2"
                    value="0"
                    checked={vehiculeData.occ_tit_2?.toString() === "0"}
                    readOnly={readOnly}
                  />
                  <label>MASCULIN</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="occ_tit_2"
                    value="1"
                    checked={vehiculeData.occ_tit_2?.toString() === "1"}
                    readOnly={readOnly}
                  />
                  <label>FÉMININ</label>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>NOM ET PRÉNOM:</label>
              <input
                type="text"
                value={vehiculeData.occ_tit_3 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>NOM D&apos;USAGE (FACULTATIF):</label>
              <input
                type="text"
                value={vehiculeData.occ_tit_4 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>NÉ.E LE:</label>
              <div className="date-input-group">
                <div className="date-field">
                  <label>JOUR</label>
                  <input
                    type="text"
                    value={vehiculeData.occ_tit_5_1 || ""}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                    placeholder="JJ"
                  />
                </div>
                <div className="date-field">
                  <label>MOIS</label>
                  <input
                    type="text"
                    value={vehiculeData.occ_tit_5_2 || ""}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                    placeholder="MM"
                  />
                </div>
                <div className="date-field">
                  <label>ANNÉE</label>
                  <input
                    type="text"
                    value={vehiculeData.occ_tit_5_3 || ""}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                    placeholder="AAAA"
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>COMMUNE DE NAISSANCE:</label>
              <input
                type="text"
                value={vehiculeData.occ_tit_6 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>DÉPARTEMENT DE NAISSANCE:</label>
              <input
                type="text"
                value={vehiculeData.occ_tit_7 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>PAYS DE NAISSANCE:</label>
              <input
                type="text"
                value={vehiculeData.occ_tit_8 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
          </>
        ) : null}

        <div className="form-group">
          <label>ETAGE / ESCALIER / APPARTEMENT:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_12 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>IMMEUBLE / RÉSIDENCE / BÂTIMENT:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_13 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>N° DE LA VOIE:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_14 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>EXTENSION (BIS, TER, ..):</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_15 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>TYPE DE VOIE (RUE, AVENUE, ..):</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_16 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>LIBELLÉ DE VOIE:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_17 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>LIEU-DIT / BP / LOCALITÉ:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_18 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>CODE POSTAL:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_19 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>COMMUNE:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_20 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>TÉLÉPHONE PORTABLE:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_21 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>ADRESSE MAIL:</label>
          <input
            type="text"
            value={vehiculeData.occ_tit_22 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="checkbox-group">
          <div>
            <input
              type="checkbox"
              checked={vehiculeData.occ_tit_23 === "1"}
              readOnly
              disabled={readOnly}
            />
            <label>
              ACQUÉRIR LE VÉHICULE DÉSIGNÉ CI-DESSUS AUX DATES ET HEURES INDIQUÉES...
            </label>
          </div>
          <div>
            <input
              type="checkbox"
              checked={vehiculeData.occ_tit_24 === "1"}
              readOnly
              disabled={readOnly}
            />
            <label>
              AVOIR ÉTÉ INFORMÉ DE LA SITUATION ADMINISTRATIVE DU VÉHICULE
            </label>
          </div>
        </div>
      </div>

      <div className="section">
        <h3>CO-TITULAIRE (En cas de demande d&apos;immatriculation)</h3>
        {console.log("Valeur de occ_cotit_0:", vehiculeData.occ_cotit_0)}
        {console.log("Type de occ_cotit_0:", typeof vehiculeData.occ_cotit_0)}
        {console.log("Données complètes du cotitulaire:", {
          occ_cotit_0: vehiculeData.occ_cotit_0,
          occ_cotit_1: vehiculeData.occ_cotit_1,
          occ_cotit_2: vehiculeData.occ_cotit_2,
          occ_cotit_3: vehiculeData.occ_cotit_3,
          occ_cotit_4: vehiculeData.occ_cotit_4,
          occ_cotit_5: vehiculeData.occ_cotit_5,
          occ_cotit_6: vehiculeData.occ_cotit_6
        })}
        <div className="radio-group">
          <label>LE VÉHICULE EST-IL DANS UN CAS DE MULTI-PROPRIÉTÉ?</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="occ_cotit_0"
                value="1"
                checked={vehiculeData.occ_cotit_0?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>OUI</label>
            </div>
            <div>
              <input
                type="radio"
                name="occ_cotit_0"
                value="0"
                checked={vehiculeData.occ_cotit_0?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>NON</label>
            </div>
          </div>
        </div>

        {vehiculeData.occ_cotit_0?.toString() === "1" && (
          <>
            <div className="form-group">
              <label>NOMBRE DE PERSONNES TITULAIRES:</label>
              <input
                type="text"
                value={vehiculeData.occ_cotit_1 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="radio-group">
              <label>VOUS ÊTES:</label>
              <div className="radio-group-child">
                <div>
                  <input
                    type="radio"
                    name="occ_cotit_2"
                    value="0"
                    checked={vehiculeData.occ_cotit_2?.toString() === "0"}
                    readOnly={readOnly}
                  />
                  <label>PERSONNE PHYSIQUE</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="occ_cotit_2"
                    value="1"
                    checked={vehiculeData.occ_cotit_2?.toString() === "1"}
                    readOnly={readOnly}
                  />
                  <label>PERSONNE MORALE</label>
                </div>
              </div>
            </div>

            {vehiculeData.occ_cotit_2?.toString() === "0" ? (
              <>
                <div className="form-group">
                  <label>NOM ET PRÉNOM:</label>
                  <input
                    type="text"
                    value={vehiculeData.occ_cotit_3 || ""}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                  />
                </div>

                <div className="form-group">
                  <label>NOM D&apos;USAGE (FACULTATIF):</label>
                  <input
                    type="text"
                    value={vehiculeData.occ_cotit_4 || ""}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="form-group">
                  <label>RAISON SOCIALE:</label>
                  <input
                    type="text"
                    value={vehiculeData.occ_cotit_5 || ""}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                  />
                </div>

                <div className="form-group">
                  <label>N° SIRET:</label>
                  <input
                    type="text"
                    value={vehiculeData.occ_cotit_6 || ""}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

DisplayTitulairesOccasion.propTypes = {
  vehiculeData: vehiculeDataPropType.isRequired,
  readOnly: PropTypes.bool
};

DisplayTitulairesOccasion.defaultProps = {
  readOnly: false
};

export default DisplayTitulairesOccasion;